import React, { useMemo } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { SnackbarProvider } from 'notistack';
import { QueryClientProvider, QueryClient } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { createBrowserHistory as createHistory } from 'history';
import App from './containers/App';
import ErrorBoundary from './components/ErrorBoundary';
import createStore from './redux/createStore';
import { theme } from './theme';
import { useVpSnackbar } from './vp-ui';

// import RSuite styles with our overrides
import './rsuite.less';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/700.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

// @TODO extract elsewhere
// eslint-disable-next-line react/prop-types
const VpQueryClientProvider = ({ children }) => {
  const { addSnackbarError } = useVpSnackbar();

  const vpQueryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          mutations: {
            onError: (error) => {
              addSnackbarError({ error });
            }
          },
          queries: {
            refetchOnWindowFocus: false
          }
        }
      }),
    []
  );

  return (
    <QueryClientProvider client={vpQueryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

// Create a history of your choosing (we're using a browser history in this case)
const history = createHistory();
const store = createStore(history, {});
ReactDOM.render(
  <ThemeProvider theme={theme}>
    <SnackbarProvider maxSnack={1} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <VpQueryClientProvider>
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </ConnectedRouter>
        </Provider>
      </VpQueryClientProvider>
    </SnackbarProvider>
  </ThemeProvider>,
  document.getElementById('root')
);
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js